export class UpdateLicenseDocumentModel {
  licence_number: string | null = null
  document_url: string | null = null
  document_title: string | null = null
}
